import { FLAT_Z, RADIUS } from '../constants';
import type { MorphBuffers } from '../types';
import { sphere } from './sphere';
import { polygonsOf, TIMEZONES } from './timezones';

const EMPTY: MorphBuffers = {
  spherePos: new Float32Array(),
  flatPos: new Float32Array(),
};

export function buildZoneLines(zone: number | null): MorphBuffers {
  if (zone == null) return EMPTY;

  const spherePos: number[] = [];
  const flatPos: number[] = [];

  const push = (lon: number, lat: number) => {
    const p = sphere(lat, lon, RADIUS.timezone);
    spherePos.push(p.x, p.y, p.z);
    flatPos.push(lon / 180, lat / 180, FLAT_Z.timezone);
  };
  const segment = (a: number[], b: number[]) => {
    const steps = Math.max(
      1,
      Math.ceil(Math.hypot(b[0] - a[0], b[1] - a[1]) / 2.5)
    );
    for (let k = 0; k < steps; k++) {
      const t0 = k / steps;
      const t1 = (k + 1) / steps;
      push(a[0] + (b[0] - a[0]) * t0, a[1] + (b[1] - a[1]) * t0);
      push(a[0] + (b[0] - a[0]) * t1, a[1] + (b[1] - a[1]) * t1);
    }
  };

  for (const z of TIMEZONES) {
    if (z.zone !== zone) continue;
    for (const rings of polygonsOf(z))
      for (const ring of rings)
        for (let i = 0; i < ring.length - 1; i++) segment(ring[i], ring[i + 1]);
  }

  return {
    spherePos: new Float32Array(spherePos),
    flatPos: new Float32Array(flatPos),
  };
}
